/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * The recording mode used by the bot
 */
export type GetBotDetailsResponseInputDataRecordingMode =
  (typeof GetBotDetailsResponseInputDataRecordingMode)[keyof typeof GetBotDetailsResponseInputDataRecordingMode]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBotDetailsResponseInputDataRecordingMode = {
  audio_only: "audio_only",
  speaker_view: "speaker_view",
  gallery_view: "gallery_view"
} as const
